<div class="upfront-payment">
  <div class="table__content">
    <div class="upfront-payment__header">
      <h5 class="typog-body-bold-large">Upfront payment</h5>
      <div class="upfront-payment-summary__card-images">
        <span class="list__inline">
          <img
            src="./assets/images/payment-visa.png"
            alt="visa credit card logo"
          />
        </span>
        <span class="list__inline">
          <img
            src="./assets/images/payment-visa-debit.png"
            alt="visa debit card logo"
          />
        </span>
        <span class="list__inline">
          <img
            src="./assets/images/payment-master-card.png"
            alt="mastercard credit card logo"
          />
        </span>
        <span class="list__inline">
          <img
            src="./assets/images/payment-maestro.png"
            alt="maestro credit card logo"
          />
        </span>
      </div>
    </div>
    <ul class="upfront-payment__list">
      <li>
        <div class="flex">
          <div class="model">
            <p class="margin--none">
              <span class="typog-body-bold"
                >{{ data?.make }} {{ data?.applianceCategory }}</span
              >
              {{ data?.model }}
            </p>
          </div>
        </div>

        <div class="list-spec" *ngIf="selected?.key_features?.length">
          <div
            class="list-spec__item"
            *ngFor="
              let feature of selected?.key_features | keyFeatures;
              let j = index
            "
          >
            <p>
              <small class="flex">
                <div class="list-spec--name">
                  {{ feature?.name }}
                </div>
                <ng-container *ngIf="feature?.value"
                  >:
                  <div class="list-spec--value">
                    {{ feature?.value }}
                  </div>
                </ng-container>
              </small>
            </p>
          </div>
        </div>
      </li>

      <li class="flex align--center">
        <dgx-components-icon
          [name]="'box-check'"
          [size]="'md'"
          class="mr-2"
        ></dgx-components-icon>
        <p class="description">
          <span>Replacement cost</span>
        </p>

        <p
          class="typog-body-bold data"
          [class.upgrade--free]="!data?.upgradeFee"
        >
          {{
            data?.upgradeFee
              ? (data.upgradeFee | currency : 'GBP')
              : '£0.00 to pay'
          }}
        </p>
      </li>

      <li class="flex align--center">
        <dgx-components-icon
          [name]="'person-dolly'"
          [size]="'md'"
          class="mr-2"
        ></dgx-components-icon>
        <p class="description">
          <span>Installation fee</span>
        </p>

        <p
          class="data"
          [class.free]="
            data?.isInstallationSelected && !data?.installation.price_gross
          "
        >
          <strong>
            <ng-container *ngIf="data?.isInstallationSelected">
              <ng-container *ngIf="data?.installation as installation">
                {{
                  installation?.price_gross && installation?.charge_customer
                    ? (installation.price_gross | currency : 'GBP')
                    : '£0.00 to pay'
                }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!data?.isInstallationAvailable">
              Not available
            </ng-container>
            <ng-container
              *ngIf="
                data?.isInstallationAvailable && !data?.isInstallationSelected
              "
            >
              Not chosen
            </ng-container>
          </strong>
        </p>
      </li>

      <li class="flex align--center">
        <dgx-components-icon
          [name]="'recycle'"
          [size]="'md'"
          class="mr-2"
        ></dgx-components-icon>
        <p class="description">
          <span>Recycling fee</span>
        </p>

        <p
          class="data"
          [class.free]="
            data?.isDisposalSelected && !data?.disposal?.price_gross
          "
        >
          <strong>
            <ng-container *ngIf="data?.isDisposalSelected">
              <ng-container *ngIf="data?.disposal as disposal">
                {{
                  disposal?.price_gross && disposal?.charge_customer
                    ? (disposal.price_gross | currency : 'GBP')
                    : '£0.00 to pay'
                }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!data?.isDisposalAvailable"
              >Not available
            </ng-container>
            <ng-container
              *ngIf="data?.isDisposalAvailable && !data?.isDisposalSelected"
            >
              Not chosen
            </ng-container>
          </strong>
        </p>
      </li>

      <li
        class="flex align--center"
        *ngIf="data?.delivery?.price_gross && data?.delivery?.charge_customer"
      >
        <p class="description">
          <strong>Delivery fee</strong>
        </p>

        <p class="data">
          {{ data?.delivery.price_gross | currency : 'GBP' }}
        </p>
      </li>

      <li *ngIf="data?.outstandingPlanAmount" class="flex align--center">
        <p class="description">
          <strong>Outstanding plan payment</strong>
        </p>

        <p class="data">
          {{ data?.outstandingPlanAmount || 0 | currency : 'GBP' }}
        </p>
      </li>
      <li class="flex align--center" *ngIf="showTotal">
        <p class="data">
          <strong>
            Total {{ data?.replacementCost | currency : 'GBP' }}
          </strong>
        </p>
      </li>
    </ul>
  </div>

  <ng-container *ngIf="data?.isProtectionSelected && isDirectDebitSummaryShown">
    <div class="table__content">
      <div class="upfront-payment__header">
        <h5>Monthly payment</h5>
        <div class="upfront-payment-summary__card-images">
          <span class="list__inline">
            <img
              src="./assets/images/payment-direct-debit.png"
              alt="direct debit logo"
            />
          </span>
        </div>
      </div>
      <div class="payment-summary">
        <div class="flex">
          <div class="model">
            <p class="margin--none">
              <strong>Protection policy</strong>
              <small>Continues for as long as you like</small>
            </p>
          </div>
          <div class="data">
            <p class="text--right">
              <strong>
                {{ data?.monthlyPayment | currency : 'GBP' }}
              </strong>
              <small class="d-block">per month</small>
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
